module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result28-50257bf0c2650f193af4c0cd8d8a0aea.png";